/** Error helpers shared by the audit-log service, sagas and UI. */
import { AuditServiceErrorBody } from 'services/auditLogs/types'

export const DEFAULT_AUDIT_ERROR_MESSAGE = 'Something went wrong. Please try again.'

export function isAuditServiceError(value: unknown): value is AuditServiceErrorBody {
  if (typeof value !== 'object' || value === null) return false
  const { error } = value as { error?: unknown }
  return typeof error === 'object' && error !== null
}

// `details` carries the field-level reason (e.g. "cursor: not a valid cursor"), so it beats the generic message.
export function getAuditErrorMessage(
  body: AuditServiceErrorBody | unknown,
  fallback: string = DEFAULT_AUDIT_ERROR_MESSAGE,
): string {
  if (!isAuditServiceError(body)) return fallback
  const { details, message } = body.error
  const firstDetail = Array.isArray(details) ? details[0] : undefined
  if (typeof firstDetail === 'string' && firstDetail) return firstDetail
  if (typeof message === 'string' && message) return message
  return fallback
}
